import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from 'components/ui/TopNavigation';
import QuickActionToolbar from 'components/ui/QuickActionToolbar';
import NotificationAlertBar from 'components/ui/NotificationAlertBar';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import PhilippineMapSVG from './components/PhilippineMapSVG';
import MapControls from './components/MapControls';
import MapLegend from './components/MapLegend';
import RegionTooltip from './components/RegionTooltip';
import RegionDetailPanel from './components/RegionDetailPanel';
import RegionRankingPanel from './components/RegionRankingPanel';
import CoverageGapAlert from './components/CoverageGapAlert';

const REGIONS_DATA = [
  {
    id: 'ncr',
    name: 'NCR',
    fullName: 'National Capital Region',
    island: 'Luzon',
    provinces: 1,
    revenue: 8420000,
    volume: 42100,
    orders: 3840,
    accounts: 284,
    coverage: 94,
    growth: 18.4,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 32 },
      { name: 'Cooking Oil 5L', share: 24 },
      { name: 'Instant Noodles (Case)', share: 18 },
      { name: 'Canned Goods Assorted', share: 14 },
      { name: 'Beverages Mixed', share: 12 },
    ],
    salesTeam: [
      { name: 'Maria Santos', role: 'Regional Manager', sales: 2840000 },
      { name: 'Jose Reyes', role: 'Area Manager', sales: 2100000 },
      { name: 'Ana Cruz', role: 'Territory Supervisor', sales: 1980000 },
    ],
  },
  {
    id: 'region1',
    name: 'Region I',
    fullName: 'Ilocos Region',
    island: 'Luzon',
    provinces: 4,
    revenue: 3150000,
    volume: 18200,
    orders: 1420,
    accounts: 118,
    coverage: 82,
    growth: 12.1,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 38 },
      { name: 'Cooking Oil 5L', share: 22 },
      { name: 'Canned Goods Assorted', share: 20 },
      { name: 'Instant Noodles (Case)', share: 12 },
      { name: 'Beverages Mixed', share: 8 },
    ],
    salesTeam: [
      { name: 'Roberto Dela Cruz', role: 'Regional Manager', sales: 1200000 },
      { name: 'Liza Fernandez', role: 'Area Manager', sales: 980000 },
      { name: 'Mark Villanueva', role: 'Territory Supervisor', sales: 970000 },
    ],
  },
  {
    id: 'car',
    name: 'CAR',
    fullName: 'Cordillera Administrative Region',
    island: 'Luzon',
    provinces: 6,
    revenue: 1820000,
    volume: 9800,
    orders: 820,
    accounts: 72,
    coverage: 68,
    growth: 5.3,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 42 },
      { name: 'Canned Goods Assorted', share: 25 },
      { name: 'Cooking Oil 5L', share: 18 },
      { name: 'Instant Noodles (Case)', share: 10 },
      { name: 'Beverages Mixed', share: 5 },
    ],
    salesTeam: [
      { name: 'Pedro Bautista', role: 'Regional Manager', sales: 820000 },
      { name: 'Carmen Aquino', role: 'Area Manager', sales: 620000 },
      { name: 'Dante Soriano', role: 'Territory Supervisor', sales: 380000 },
    ],
  },
  {
    id: 'region2',
    name: 'Region II',
    fullName: 'Cagayan Valley',
    island: 'Luzon',
    provinces: 5,
    revenue: 2240000,
    volume: 12400,
    orders: 980,
    accounts: 95,
    coverage: 74,
    growth: 8.7,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 45 },
      { name: 'Cooking Oil 5L', share: 20 },
      { name: 'Canned Goods Assorted', share: 18 },
      { name: 'Instant Noodles (Case)', share: 10 },
      { name: 'Beverages Mixed', share: 7 },
    ],
    salesTeam: [
      { name: 'Noel Castillo', role: 'Regional Manager', sales: 980000 },
      { name: 'Grace Mendoza', role: 'Area Manager', sales: 720000 },
      { name: 'Ryan Tolentino', role: 'Territory Supervisor', sales: 540000 },
    ],
  },
  {
    id: 'region3',
    name: 'Region III',
    fullName: 'Central Luzon',
    island: 'Luzon',
    provinces: 7,
    revenue: 5680000,
    volume: 28400,
    orders: 2480,
    accounts: 198,
    coverage: 88,
    growth: 15.2,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 35 },
      { name: 'Cooking Oil 5L', share: 26 },
      { name: 'Instant Noodles (Case)', share: 20 },
      { name: 'Canned Goods Assorted', share: 12 },
      { name: 'Beverages Mixed', share: 7 },
    ],
    salesTeam: [
      { name: 'Ernesto Ramos', role: 'Regional Manager', sales: 2100000 },
      { name: 'Sheila Pascual', role: 'Area Manager', sales: 1840000 },
      { name: 'Victor Navarro', role: 'Territory Supervisor', sales: 1740000 },
    ],
  },
  {
    id: 'region4a',
    name: 'Region IV-A',
    fullName: 'CALABARZON',
    island: 'Luzon',
    provinces: 5,
    revenue: 6240000,
    volume: 31200,
    orders: 2840,
    accounts: 224,
    coverage: 91,
    growth: 16.8,
    topProducts: [
      { name: 'Cooking Oil 5L', share: 30 },
      { name: 'Premium Rice 25kg', share: 28 },
      { name: 'Instant Noodles (Case)', share: 22 },
      { name: 'Beverages Mixed', share: 12 },
      { name: 'Canned Goods Assorted', share: 8 },
    ],
    salesTeam: [
      { name: 'Maricel Ocampo', role: 'Regional Manager', sales: 2400000 },
      { name: 'Dennis Flores', role: 'Area Manager', sales: 1980000 },
      { name: 'Rowena Aguilar', role: 'Territory Supervisor', sales: 1860000 },
    ],
  },
  {
    id: 'region4b',
    name: 'Region IV-B',
    fullName: 'MIMAROPA',
    island: 'Luzon',
    provinces: 5,
    revenue: 1480000,
    volume: 7800,
    orders: 640,
    accounts: 58,
    coverage: 62,
    growth: -2.4,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 40 },
      { name: 'Canned Goods Assorted', share: 28 },
      { name: 'Cooking Oil 5L', share: 18 },
      { name: 'Instant Noodles (Case)', share: 9 },
      { name: 'Beverages Mixed', share: 5 },
    ],
    salesTeam: [
      { name: 'Arnel Dizon', role: 'Regional Manager', sales: 620000 },
      { name: 'Lourdes Macaraeg', role: 'Area Manager', sales: 480000 },
      { name: 'Freddie Lacson', role: 'Territory Supervisor', sales: 380000 },
    ],
  },
  {
    id: 'region5',
    name: 'Region V',
    fullName: 'Bicol Region',
    island: 'Luzon',
    provinces: 6,
    revenue: 2840000,
    volume: 14800,
    orders: 1240,
    accounts: 108,
    coverage: 78,
    growth: 9.4,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 36 },
      { name: 'Cooking Oil 5L', share: 24 },
      { name: 'Canned Goods Assorted', share: 22 },
      { name: 'Instant Noodles (Case)', share: 12 },
      { name: 'Beverages Mixed', share: 6 },
    ],
    salesTeam: [
      { name: 'Cecilia Buenaventura', role: 'Regional Manager', sales: 1100000 },
      { name: 'Rodrigo Espiritu', role: 'Area Manager', sales: 920000 },
      { name: 'Teresita Abad', role: 'Territory Supervisor', sales: 820000 },
    ],
  },
  {
    id: 'region6',
    name: 'Region VI',
    fullName: 'Western Visayas',
    island: 'Visayas',
    provinces: 6,
    revenue: 3420000,
    volume: 17400,
    orders: 1480,
    accounts: 128,
    coverage: 84,
    growth: 11.6,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 34 },
      { name: 'Cooking Oil 5L', share: 26 },
      { name: 'Instant Noodles (Case)', share: 20 },
      { name: 'Canned Goods Assorted', share: 14 },
      { name: 'Beverages Mixed', share: 6 },
    ],
    salesTeam: [
      { name: 'Herminia Salazar', role: 'Regional Manager', sales: 1380000 },
      { name: 'Bonifacio Tan', role: 'Area Manager', sales: 1080000 },
      { name: 'Rosario Lim', role: 'Territory Supervisor', sales: 960000 },
    ],
  },
  {
    id: 'region7',
    name: 'Region VII',
    fullName: 'Central Visayas',
    island: 'Visayas',
    provinces: 4,
    revenue: 4180000,
    volume: 21200,
    orders: 1840,
    accounts: 158,
    coverage: 87,
    growth: 14.2,
    topProducts: [
      { name: 'Cooking Oil 5L', share: 32 },
      { name: 'Premium Rice 25kg', share: 28 },
      { name: 'Instant Noodles (Case)', share: 22 },
      { name: 'Beverages Mixed', share: 10 },
      { name: 'Canned Goods Assorted', share: 8 },
    ],
    salesTeam: [
      { name: 'Eduardo Gomez', role: 'Regional Manager', sales: 1680000 },
      { name: 'Milagros Uy', role: 'Area Manager', sales: 1320000 },
      { name: 'Alfredo Sy', role: 'Territory Supervisor', sales: 1180000 },
    ],
  },
  {
    id: 'region8',
    name: 'Region VIII',
    fullName: 'Eastern Visayas',
    island: 'Visayas',
    provinces: 6,
    revenue: 1960000,
    volume: 10200,
    orders: 840,
    accounts: 82,
    coverage: 71,
    growth: 3.8,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 38 },
      { name: 'Canned Goods Assorted', share: 26 },
      { name: 'Cooking Oil 5L', share: 20 },
      { name: 'Instant Noodles (Case)', share: 10 },
      { name: 'Beverages Mixed', share: 6 },
    ],
    salesTeam: [
      { name: 'Conrado Villafuerte', role: 'Regional Manager', sales: 820000 },
      { name: 'Natividad Ponce', role: 'Area Manager', sales: 640000 },
      { name: 'Simplicio Delos Reyes', role: 'Territory Supervisor', sales: 500000 },
    ],
  },
  {
    id: 'region9',
    name: 'Region IX',
    fullName: 'Zamboanga Peninsula',
    island: 'Mindanao',
    provinces: 3,
    revenue: 1640000,
    volume: 8600,
    orders: 720,
    accounts: 68,
    coverage: 65,
    growth: -4.2,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 42 },
      { name: 'Canned Goods Assorted', share: 28 },
      { name: 'Cooking Oil 5L', share: 18 },
      { name: 'Instant Noodles (Case)', share: 8 },
      { name: 'Beverages Mixed', share: 4 },
    ],
    salesTeam: [
      { name: 'Arsenio Macapagal', role: 'Regional Manager', sales: 680000 },
      { name: 'Felicidad Moro', role: 'Area Manager', sales: 540000 },
      { name: 'Gregorio Hadji', role: 'Territory Supervisor', sales: 420000 },
    ],
  },
  {
    id: 'region10',
    name: 'Region X',
    fullName: 'Northern Mindanao',
    island: 'Mindanao',
    provinces: 5,
    revenue: 2680000,
    volume: 13800,
    orders: 1140,
    accounts: 102,
    coverage: 76,
    growth: 7.9,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 36 },
      { name: 'Cooking Oil 5L', share: 24 },
      { name: 'Canned Goods Assorted', share: 22 },
      { name: 'Instant Noodles (Case)', share: 12 },
      { name: 'Beverages Mixed', share: 6 },
    ],
    salesTeam: [
      { name: 'Victorino Cagayan', role: 'Regional Manager', sales: 1080000 },
      { name: 'Remedios Bukidnon', role: 'Area Manager', sales: 860000 },
      { name: 'Leandro Misamis', role: 'Territory Supervisor', sales: 740000 },
    ],
  },
  {
    id: 'region11',
    name: 'Region XI',
    fullName: 'Davao Region',
    island: 'Mindanao',
    provinces: 5,
    revenue: 3840000,
    volume: 19600,
    orders: 1680,
    accounts: 142,
    coverage: 85,
    growth: 13.5,
    topProducts: [
      { name: 'Cooking Oil 5L', share: 30 },
      { name: 'Premium Rice 25kg', share: 30 },
      { name: 'Instant Noodles (Case)', share: 20 },
      { name: 'Beverages Mixed', share: 12 },
      { name: 'Canned Goods Assorted', share: 8 },
    ],
    salesTeam: [
      { name: 'Augusto Davao', role: 'Regional Manager', sales: 1540000 },
      { name: 'Perla Samal', role: 'Area Manager', sales: 1220000 },
      { name: 'Renato Compostela', role: 'Territory Supervisor', sales: 1080000 },
    ],
  },
  {
    id: 'region12',
    name: 'Region XII',
    fullName: 'SOCCSKSARGEN',
    island: 'Mindanao',
    provinces: 4,
    revenue: 2120000,
    volume: 11000,
    orders: 920,
    accounts: 88,
    coverage: 72,
    growth: 6.2,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 38 },
      { name: 'Cooking Oil 5L', share: 24 },
      { name: 'Canned Goods Assorted', share: 20 },
      { name: 'Instant Noodles (Case)', share: 12 },
      { name: 'Beverages Mixed', share: 6 },
    ],
    salesTeam: [
      { name: 'Domingo Cotabato', role: 'Regional Manager', sales: 860000 },
      { name: 'Erlinda Sultan', role: 'Area Manager', sales: 680000 },
      { name: 'Florencio Sarangani', role: 'Territory Supervisor', sales: 580000 },
    ],
  },
  {
    id: 'caraga',
    name: 'CARAGA',
    fullName: 'Caraga Region',
    island: 'Mindanao',
    provinces: 5,
    revenue: 1380000,
    volume: 7200,
    orders: 580,
    accounts: 54,
    coverage: 60,
    growth: -1.8,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 44 },
      { name: 'Canned Goods Assorted', share: 26 },
      { name: 'Cooking Oil 5L', share: 18 },
      { name: 'Instant Noodles (Case)', share: 8 },
      { name: 'Beverages Mixed', share: 4 },
    ],
    salesTeam: [
      { name: 'Isidro Agusan', role: 'Regional Manager', sales: 580000 },
      { name: 'Josefina Surigao', role: 'Area Manager', sales: 460000 },
      { name: 'Lamberto Dinagat', role: 'Territory Supervisor', sales: 340000 },
    ],
  },
  {
    id: 'barmm',
    name: 'BARMM',
    fullName: 'Bangsamoro',
    island: 'Mindanao',
    provinces: 5,
    revenue: 980000,
    volume: 5200,
    orders: 420,
    accounts: 42,
    coverage: 55,
    growth: 4.1,
    topProducts: [
      { name: 'Premium Rice 25kg', share: 48 },
      { name: 'Canned Goods Assorted', share: 28 },
      { name: 'Cooking Oil 5L', share: 14 },
      { name: 'Instant Noodles (Case)', share: 6 },
      { name: 'Beverages Mixed', share: 4 },
    ],
    salesTeam: [
      { name: 'Hadji Murad', role: 'Regional Manager', sales: 420000 },
      { name: 'Sitti Aminah', role: 'Area Manager', sales: 320000 },
      { name: 'Omar Sharif', role: 'Territory Supervisor', sales: 240000 },
    ],
  },
];

export default function PhilippineMapVisualization() {
  const navigate = useNavigate();
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [hoveredRegion, setHoveredRegion] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [activeMetric, setActiveMetric] = useState('revenue');
  const [timePeriod, setTimePeriod] = useState('month');
  const [zoom, setZoom] = useState(100);
  const [showDetailPanel, setShowDetailPanel] = useState(false);
  const [showMobileRanking, setShowMobileRanking] = useState(false);

  const handleRegionClick = useCallback((region) => {
    setSelectedRegion(region);
    setShowDetailPanel(true);
    setHoveredRegion(null);
  }, []);

  const handleRegionHover = useCallback((region, position) => {
    setHoveredRegion(region);
    setTooltipPosition(position);
  }, []);

  const handleRegionLeave = useCallback(() => {
    setHoveredRegion(null);
  }, []);

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 15, 200));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 15, 60));
  const handleZoomReset = () => setZoom(100);

  const handleCloseDetail = () => {
    setShowDetailPanel(false);
    setSelectedRegion(null);
  };

  const handleAction = (action) => {
    if (action === 'export-map') {
      alert('Map export initiated. File will be downloaded shortly.');
    } else if (action === 'filter') {
      setShowMobileRanking(prev => !prev);
    }
  };

  const totalRevenue = REGIONS_DATA?.reduce((s, r) => s + r?.revenue, 0);
  const totalOrders = REGIONS_DATA?.reduce((s, r) => s + r?.orders, 0);
  const totalAccounts = REGIONS_DATA?.reduce((s, r) => s + r?.accounts, 0);
  const avgCoverage = Math.round(REGIONS_DATA?.reduce((s, r) => s + r?.coverage, 0) / REGIONS_DATA?.length);

  const formatPHP = (v) => {
    if (v >= 1000000) return `₱${(v / 1000000)?.toFixed(1)}M`;
    if (v >= 1000) return `₱${(v / 1000)?.toFixed(0)}K`;
    return `₱${v?.toLocaleString()}`;
  };

  return (
    <div className="min-h-screen bg-background page-gradient-bg">
      <TopNavigation />
      <NotificationAlertBar />
      <QuickActionToolbar onAction={handleAction} />
      {/* Page Header */}
      <div className="border-b border-border px-4 md:px-6 lg:px-8 py-4" style={{ background: 'var(--color-card)' }}>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <Icon name="Map" size={20} color="var(--color-primary)" strokeWidth={2} />
              <h1 className="font-heading font-bold text-foreground text-lg md:text-xl lg:text-2xl">
                Philippine Map Visualization
              </h1>
            </div>
            <p className="font-caption text-sm text-muted-foreground">
              Interactive sales heatmap across all Philippine regions • {new Date()?.toLocaleDateString('en-PH', { month: 'long', year: 'numeric' })}
            </p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <Button
              variant="outline"
              size="sm"
              iconName="BarChart2"
              iconPosition="left"
              iconSize={14}
              onClick={() => navigate('/performance-analytics')}
            >
              Analytics
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="BrainCircuit"
              iconPosition="left"
              iconSize={14}
              onClick={() => navigate('/ai-intelligence-reports')}
            >
              AI Reports
            </Button>
          </div>
        </div>

        {/* Summary KPIs */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
          {[
            { label: 'Total Revenue', value: formatPHP(totalRevenue), icon: 'DollarSign', color: '#DC2626', bgStyle: { background: 'rgba(220, 38, 38, 0.1)', border: '1px solid rgba(220, 38, 38, 0.2)' } },
            { label: 'Total Orders', value: totalOrders?.toLocaleString(), icon: 'ShoppingCart', color: '#D4AF37', bgStyle: { background: 'rgba(212, 175, 55, 0.1)', border: '1px solid rgba(212, 175, 55, 0.2)' } },
            { label: 'Active Accounts', value: totalAccounts?.toLocaleString(), icon: 'Users', color: '#22C55E', bgStyle: { background: 'rgba(34, 197, 94, 0.1)', border: '1px solid rgba(34, 197, 94, 0.2)' } },
            { label: 'Avg Coverage', value: `${avgCoverage}%`, icon: 'MapPin', color: '#8B92A5', bgStyle: { background: 'rgba(139, 146, 165, 0.1)', border: '1px solid rgba(139, 146, 165, 0.2)' } },
          ]?.map((kpi) => (
            <div key={kpi?.label} className="rounded-lg px-3 py-2.5 flex items-center gap-2.5" style={kpi?.bgStyle}>
              <div className="flex-shrink-0">
                <Icon name={kpi?.icon} size={18} color={kpi?.color} strokeWidth={2} />
              </div>
              <div className="min-w-0">
                <p className="font-data text-base md:text-lg font-bold text-foreground leading-tight">{kpi?.value}</p>
                <p className="font-caption text-xs text-muted-foreground truncate">{kpi?.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Main Content */}
      <div className="flex-1 flex flex-col lg:flex-row gap-0 overflow-hidden">

        {/* Left Controls Panel - Desktop */}
        <div className="hidden lg:flex flex-col gap-3 p-4 w-52 xl:w-56 flex-shrink-0 overflow-y-auto custom-scrollbar border-r border-border" style={{ background: 'var(--color-card)' }}>
          <MapControls
            activeMetric={activeMetric}
            setActiveMetric={setActiveMetric}
            timePeriod={timePeriod}
            setTimePeriod={setTimePeriod}
            zoom={zoom}
            onZoomIn={handleZoomIn}
            onZoomOut={handleZoomOut}
            onReset={handleZoomReset}
          />
          <MapLegend activeMetric={activeMetric} />
        </div>

        {/* Map Area */}
        <div className="flex-1 relative overflow-hidden" style={{ minHeight: '400px', background: 'linear-gradient(135deg, #0D1117, #111318)' }}>
          {/* Mobile Controls Bar */}
          <div className="lg:hidden flex items-center gap-2 p-3 border-b border-border overflow-x-auto" style={{ background: 'var(--color-card)' }}>
            <div className="flex gap-1 flex-shrink-0">
              {['revenue', 'volume', 'accounts']?.map((m) => (
                <button
                  key={m}
                  onClick={() => setActiveMetric(m)}
                  className={`px-3 py-1.5 rounded-md text-xs font-caption font-medium transition-all duration-200 press-effect capitalize whitespace-nowrap`}
                  style={activeMetric === m ? { background: 'linear-gradient(135deg, #DC2626, #B91C1C)', color: '#FFFFFF' } : { background: 'var(--color-muted)', color: 'var(--color-muted-foreground)' }}
                >
                  {m}
                </button>
              ))}
            </div>
            <div className="w-px h-5 flex-shrink-0" style={{ background: 'var(--color-border)' }} />
            <div className="flex gap-1 flex-shrink-0">
              {['week', 'month', 'quarter', 'year']?.map((t) => (
                <button
                  key={t}
                  onClick={() => setTimePeriod(t)}
                  className={`px-3 py-1.5 rounded-md text-xs font-caption font-medium transition-all duration-200 press-effect capitalize whitespace-nowrap`}
                  style={timePeriod === t ? { background: 'linear-gradient(135deg, #DC2626, #B91C1C)', color: '#FFFFFF' } : { background: 'var(--color-muted)', color: 'var(--color-muted-foreground)' }}
                >
                  {t?.charAt(0)?.toUpperCase() + t?.slice(1)}
                </button>
              ))}
            </div>
            <div className="flex gap-1 ml-auto flex-shrink-0">
              <button onClick={handleZoomOut} className="w-8 h-8 flex items-center justify-center rounded-md border border-border text-muted-foreground hover:bg-muted press-effect" style={{ background: 'var(--color-card)' }}>
                <Icon name="Minus" size={14} color="currentColor" strokeWidth={2} />
              </button>
              <button onClick={handleZoomIn} className="w-8 h-8 flex items-center justify-center rounded-md border border-border text-muted-foreground hover:bg-muted press-effect" style={{ background: 'var(--color-card)' }}>
                <Icon name="Plus" size={14} color="currentColor" strokeWidth={2} />
              </button>
            </div>
          </div>

          {/* SVG Map */}
          <div className="w-full h-full" style={{ minHeight: '380px', maxHeight: 'calc(100vh - 320px)' }}>
            <PhilippineMapSVG
              regionsData={REGIONS_DATA}
              selectedRegion={selectedRegion}
              onRegionClick={handleRegionClick}
              onRegionHover={handleRegionHover}
              onRegionLeave={handleRegionLeave}
              zoom={zoom}
            />
          </div>

          {/* Tooltip */}
          {hoveredRegion && !showDetailPanel && (
            <RegionTooltip
              region={hoveredRegion}
              position={tooltipPosition}
              onClose={() => setHoveredRegion(null)}
            />
          )}

          {/* Map Legend - Mobile overlay */}
          <div className="lg:hidden absolute bottom-4 left-4">
            <MapLegend activeMetric={activeMetric} />
          </div>

          {/* Click hint */}
          {!selectedRegion && (
            <div className="absolute top-4 left-1/2 -translate-x-1/2 backdrop-blur-sm border border-border rounded-full px-4 py-2 shadow-sm pointer-events-none" style={{ background: 'rgba(26, 29, 36, 0.9)' }}>
              <p className="font-caption text-xs text-muted-foreground flex items-center gap-1.5 whitespace-nowrap">
                <Icon name="MousePointer" size={12} color="currentColor" strokeWidth={2} />
                Click a region for detailed insights
              </p>
            </div>
          )}
        </div>

        {/* Right Panel */}
        <div className="hidden lg:flex flex-col gap-3 p-4 w-72 xl:w-80 flex-shrink-0 overflow-y-auto custom-scrollbar border-l border-border" style={{ background: 'var(--color-card)' }}>
          {showDetailPanel && selectedRegion ? (
            <div className="flex-1 flex flex-col" style={{ minHeight: '400px' }}>
              <RegionDetailPanel region={selectedRegion} onClose={handleCloseDetail} />
            </div>
          ) : (
            <>
              <div className="flex-1" style={{ minHeight: '300px' }}>
                <RegionRankingPanel
                  regions={REGIONS_DATA}
                  selectedRegion={selectedRegion}
                  onSelectRegion={(r) => { setSelectedRegion(r); setShowDetailPanel(true); }}
                  activeMetric={activeMetric}
                />
              </div>
              <CoverageGapAlert regions={REGIONS_DATA} />
            </>
          )}
        </div>
      </div>
      {/* Mobile Bottom Sheet - Region Detail */}
      {showDetailPanel && selectedRegion && (
        <div className="lg:hidden fixed inset-0 z-50 flex flex-col justify-end">
          <div
            className="absolute inset-0"
            style={{ background: 'rgba(0,0,0,0.6)' }}
            onClick={handleCloseDetail}
          />
          <div className="relative rounded-t-2xl shadow-2xl max-h-[75vh] flex flex-col overflow-hidden" style={{ background: 'var(--color-card)' }}>
            <div className="flex items-center justify-center pt-3 pb-1">
              <div className="w-10 h-1 rounded-full" style={{ background: 'var(--color-border)' }} />
            </div>
            <div className="flex-1 overflow-y-auto custom-scrollbar">
              <RegionDetailPanel region={selectedRegion} onClose={handleCloseDetail} />
            </div>
          </div>
        </div>
      )}
      {/* Mobile Rankings Toggle */}
      <div className="lg:hidden fixed bottom-16 right-4 z-40 flex flex-col gap-2">
        <button
          onClick={() => setShowMobileRanking(prev => !prev)}
          className="flex items-center gap-2 px-4 py-2.5 text-white rounded-full shadow-lg font-caption text-sm font-medium press-effect min-h-[44px]"
          style={{ background: 'linear-gradient(135deg, #DC2626, #B91C1C)', boxShadow: '0 4px 16px rgba(220, 38, 38, 0.4)' }}
        >
          <Icon name="List" size={16} color="currentColor" strokeWidth={2} />
          Rankings
        </button>
      </div>
      {/* Mobile Rankings Panel */}
      {showMobileRanking && (
        <div className="lg:hidden fixed inset-0 z-50 flex flex-col justify-end">
          <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.6)' }} onClick={() => setShowMobileRanking(false)} />
          <div className="relative rounded-t-2xl shadow-2xl max-h-[70vh] flex flex-col overflow-hidden" style={{ background: 'var(--color-card)' }}>
            <div className="flex items-center justify-center pt-3 pb-1">
              <div className="w-10 h-1 rounded-full" style={{ background: 'var(--color-border)' }} />
            </div>
            <div className="flex-1 overflow-hidden p-4 flex flex-col gap-3">
              <RegionRankingPanel
                regions={REGIONS_DATA}
                selectedRegion={selectedRegion}
                onSelectRegion={(r) => {
                  setSelectedRegion(r);
                  setShowMobileRanking(false);
                  setShowDetailPanel(true);
                }}
                activeMetric={activeMetric}
              />
              <CoverageGapAlert regions={REGIONS_DATA} />
            </div>
          </div>
        </div>
      )}
      {/* Footer */}
      <footer className="hidden lg:block border-t border-border px-6 py-3" style={{ background: 'var(--color-card)' }}>
        <div className="flex items-center justify-between">
          <p className="font-caption text-xs text-muted-foreground">
            &copy; {new Date()?.getFullYear()} iSYNC Distribution Ordering &amp; Sales Intelligence System • Philippine Map Visualization
          </p>
          <p className="font-caption text-xs text-muted-foreground">
            Data as of {new Date()?.toLocaleDateString('en-PH', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        </div>
      </footer>
    </div>
  );
}